import { render, staticRenderFns } from "./RecurrenceRule.vue?vue&type=template&id=c87ea20a&scoped=true"
import script from "./RecurrenceRule.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecurrenceRule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecurrenceRule.vue?vue&type=style&index=0&id=c87ea20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87ea20a",
  null
  
)

export default component.exports